import {
  formatPropertyCustomerRole,
  normalizePropertyCustomerRole,
} from "../../../../../../_shared/_logic/customer-roles"
import { normalizeCode, normalizeId } from "./normalization"

const buildingContactRoleOrder = ["MANAGER", "OWNER", "OTHER", "TENANT", "BILLING_CONTACT"] as const
const residentialContactRoleOrder = [
  "TENANT",
  "OWNER",
  "OTHER",
  "MANAGER",
  "BILLING_CONTACT",
] as const

const normalizeRecipientRole = (value: unknown) => {
  const raw = normalizeCode(value)
  const enumValue = raw.includes(".") ? raw.split(".").at(-1) : raw

  return normalizePropertyCustomerRole(enumValue)
}

export const formatRoleLabel = (value: unknown) => {
  return formatPropertyCustomerRole(normalizeRecipientRole(value))
}

export const workOrderUnitScope = (
  property: Property | undefined,
  propertyUnitId: string | null | undefined,
) => {
  const normalizedUnitId = normalizeId(propertyUnitId)
  const unit = normalizedUnitId
    ? (property?.units ?? []).find((entry) => normalizeId(entry.id) === normalizedUnitId)
    : null

  return unit?.unit_type === "RESIDENTIAL" ? "RESIDENTIAL" : "BUILDING"
}

export const sortRecipientsByContactOrder = (
  recipients: NonNullable<WorkOrder["recipients"]>,
  unitScope: "BUILDING" | "RESIDENTIAL",
) => {
  const roleOrder =
    unitScope === "RESIDENTIAL" ? residentialContactRoleOrder : buildingContactRoleOrder
  const roleRank = new Map(roleOrder.map((role, index) => [role, index]))

  return recipients
    .map((recipient, index) => ({ recipient, index }))
    .sort((left, right) => {
      const leftRank =
        roleRank.get(normalizeRecipientRole(left.recipient.role)) ?? Number.MAX_SAFE_INTEGER
      const rightRank =
        roleRank.get(normalizeRecipientRole(right.recipient.role)) ?? Number.MAX_SAFE_INTEGER

      return leftRank - rightRank || left.index - right.index
    })
    .map((entry) => entry.recipient)
}
